import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGl = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.35024 4.07427V14.5M5.35024 4.07427L12.7096 2.84771M5.35024 4.07427L3.29004 2.70079M3.29004 2.70079L10.2255 1.5L12.7096 2.84771V13.2734L5.35024 14.5L3.29004 13.1265V2.70079Z",
		stroke: "currentColor",
		strokeLinejoin: "round"
	})
});
export default SvgGl;
